import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import React from "react";
import { ChartProps } from "./types";
import getChartOptions from "./utils/ChartOptions";
HighchartsMore(Highcharts);

type Props = {
  options: ChartProps;
  modifyOptions?: (options: any) => any;
  colors?: any;
};
const HighChart = (props: Props) => {
  const { options, modifyOptions, colors } = props;
  const [renderAgain, setRenderAgain] = React.useState(0);
  const chartRef = React.useRef<Highcharts.Chart | null | undefined>(null);
  const DISABLE_ANIMATION = true;
  let chartOptions: any = getChartOptions(options, DISABLE_ANIMATION, colors);
  if (modifyOptions) {
    chartOptions = modifyOptions(chartOptions);
  }
  React.useEffect(() => {
    if (chartRef.current) {
      chartRef.current?.update(chartOptions as any, true);
    }
  }, [chartOptions, chartRef.current]);

  React.useEffect(() => {
    let iv = 0;
    if (props.options.type === "donut" || props.options.type === "pie") {
      iv = window.setTimeout(() => {
        setRenderAgain((v) => v + 1);
      }, 1);
    }
    return () => {
      if (iv) {
        window.clearTimeout(iv);
      }
    };
  }, [options]);
  return (
    <HighchartsReact
      ref={(ch) => {
        chartRef.current = ch?.chart;
      }}
      updateArgs={[true, true, true]}
      highcharts={Highcharts}
      options={chartOptions}
      oneToOne
    />
  );
};

export default HighChart;
